import { TAB_NAME } from '@/components/DataGenerationHistory/constants';
import { downloadHistoryStore } from '@/stores/downloadHistoryStore';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { IconButton } from '@mui/material';
import { styles } from './styles';

export const DataGenerationHistoryButton = () => {
  const setOpen = downloadHistoryStore.use.setOpen();

  return (
    <IconButton
      onClick={() => setOpen(true)}
      data-testid="download-history-icon"
      aria-label={TAB_NAME}
    >
      <CloudDownloadOutlinedIcon sx={styles.downloadIcon} />
    </IconButton>
  );
};
